import { render, staticRenderFns } from "./CompanyName.vue?vue&type=template&id=9df8d744&scoped=true&"
import script from "./CompanyName.vue?vue&type=script&lang=js&"
export * from "./CompanyName.vue?vue&type=script&lang=js&"
import style0 from "./CompanyName.vue?vue&type=style&index=0&id=9df8d744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df8d744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9df8d744')) {
      api.createRecord('9df8d744', component.options)
    } else {
      api.reload('9df8d744', component.options)
    }
    module.hot.accept("./CompanyName.vue?vue&type=template&id=9df8d744&scoped=true&", function () {
      api.rerender('9df8d744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/CompanyName.vue"
export default component.exports